export { default as DetalleMovimientosGeneral } from "./Detalle";